// 电表路由
import MeterLayout from '@/layout/index.vue'
import MeterHome from '@/views/meter/home.vue'
import MeterList from '@/views/meter/list.vue'
import MeterCompare from '@/views/meter/compare.vue'
import MeterHistory from '@/views/meter/history.vue'
import MeterStation from '@/views/meter/station.vue'
import MeterCollector from '@/views/meter/collector.vue'
import MeterData from '@/views/meter/data.vue'
import MeterMenu from '@/views/meter/menu.vue'
import MeterReport from '@/views/meter/report.vue'
import MeterSettlement from '@/views/meter/settlement.vue'
import MeterLizhuSettlement from '@/views/meter/lizhuSettlement.vue'
import MeterAlarm from '@/views/meter/alarm.vue'
import MeterPowerdatas from '@/views/meter/powerdatas.vue'
import MeterLink from '@/views/meter/link.vue'

/** 澳洲报表导出 */
import MeterAusOnereport from '@/views/meter/aus/onereport.vue'
import MeterAusTworeport from '@/views/meter/aus/tworeport.vue'
import MeterAusDetails from '@/views/meter/aus/details.vue'
import MeterAusBillsettings from '@/views/meter/aus/billsettings.vue'

const router = {
  path: '/layout',
  name: 'meterLayout',
  component: MeterLayout,
  redirect: '/home',
  children: [
    {
      path: '/meter/home',
      name: 'meter_home',
      meta: {
        showTab: true,
        name: 'meter_home mulshow',
        title: '电表电站-概览'
      },
      component: MeterHome
    },
    {
      path: '/meter/list',
      name: 'meter_list',
      meta: {
        showTab: true,
        name: 'meter_list mulshow',
        title: '电表电站-实时列表'
      },
      component: MeterList
    },
    {
      path: '/meter/compare',
      name: 'meter_compare',
      meta: {
        showTab: true,
        name: 'meter_compare mulshow',
        title: '电表电站-对比分析'
      },
      component: MeterCompare
    },
    {
      path: '/meter/history',
      name: 'meter_history',
      meta: {
        showTab: true,
        name: 'meter_history mulshow',
        title: '电表电站-历史数据'
      },
      component: MeterHistory
    },
    {
      path: '/meter/station',
      name: 'meter_station',
      meta: {
        showTab: true,
        name: 'meter_station mulshow',
        title: '电表电站-设置'
      },
      component: MeterStation
    },
    {
      path: '/meter/collector',
      name: 'meter_collector',
      meta: {
        showTab: true,
        name: 'meter_collector mulshow',
        title: '电表电站-采集器列表'
      },
      component: MeterCollector
    },
    {
      path: '/meter/data',
      name: 'meter_data',
      meta: {
        showTab: true,
        name: 'meter_data mulshow',
        title: '电表电站-整点数据查询'
      },
      component: MeterData
    },
    {
      path: '/meter/menu',
      name: 'meter_menu',
      meta: {
        showTab: true,
        name: 'meter_menu mulshow',
        title: '电表 抄表菜单'
      },
      component: MeterMenu
    },
    {
      path: '/meter/report',
      name: 'meter_report',
      meta: {
        showTab: true,
        name: 'meter_report mulshow',
        title: '电表电站-报表导出'
      },
      component: MeterReport
    },
    {
      path: '/meter/settlement',
      name: 'meter_settlement',
      meta: {
        showTab: true,
        name: 'meter_settlement mulshow',
        title: '电表电站-结算报告'
      },
      component: MeterSettlement
    },
    {
      path: '/meter/lizhuSettlement',
      name: 'meter_lizhuSettlement',
      meta: {
        showTab: false,
        name: 'meter_lizhuSettlement mulshow',
        title: '电表电站-结算报告'
      },
      component: MeterLizhuSettlement
    },
    {
      path: '/meter/alarm',
      name: 'meter_alarm',
      meta: {
        showTab: true,
        name: 'meter_alarm mulshow',
        title: '电表电站-报警列表'
      },
      component: MeterAlarm
    },
    // 澳洲报表1
    {
      path: '/meter/aus/onereport',
      name: 'meter_onereport',
      meta: {
        showTab: false,
        name: 'meter_onereport',
        title: '电表 澳洲报表导出'
      },
      component: MeterAusOnereport
    },
    // 澳洲报表2
    {
      path: '/meter/aus/tworeport',
      name: 'meter_tworeport',
      meta: {
        showTab: false,
        name: 'meter_tworeport',
        title: '电表 澳洲报表导出'
      },
      component: MeterAusTworeport
    },
    // 澳洲电费详情
    {
      path: '/meter/aus/details',
      name: 'meter_details',
      meta: {
        showTab: false,
        name: 'meter_details',
        title: '电表 澳洲电费详情'
      },
      component: MeterAusDetails
    },
    // 澳洲电费单设置
    {
      path: '/meter/aus/billsettings',
      name: 'meter_billsettings',
      meta: {
        showTab: true,
        name: 'meter_billsettings',
        title: '电表 澳洲电费单设置'
      },
      component: MeterAusBillsettings
    },
    // 电能数据--统计电量
    {
      path: '/meter/powerdatas',
      name: 'meter_powerdatas',
      meta: {
        showTab: true,
        name: 'meter_powerdatas mulshow',
        title: '电表 统计电量'
      },
      component: MeterPowerdatas
    },
    {
      path: '/meter/link',
      name: 'meter_link',
      meta: {
        showTab: true,
        name: 'meter_link mulshow',
        title: '电表 打开大屏'
      },
      component: MeterLink
    },
  ]
}

export default router
